/* Stock defaults apply to collection entry, while an explicit removal remains possible. */
(() => {
  const key = 'p26-world-stock-choice';
  const current = new URL(location.href);
  const collection = current.pathname.includes('/collections/') || current.pathname === '/search';
  const storage = {get(){try{return sessionStorage.getItem(key)}catch{return null}},set(v){try{sessionStorage.setItem(key,v)}catch{}}};
  if (collection && !current.searchParams.has('filter.v.availability') && storage.get() !== 'all') {
    current.searchParams.set('filter.v.availability','1');
    location.replace(current.href);
    return;
  }
  document.addEventListener('change',e=>{
    if(e.target.name==='filter.v.availability') storage.set(e.target.checked?'in-stock':'all');
  },true);
  document.addEventListener('click',e=>{
    const link=e.target.closest('a');if(!link)return;
    if(link.closest('facet-remove')){const next=new URL(link.href,location.href);if(!next.searchParams.has('filter.v.availability'))storage.set('all');return;}
    const url=new URL(link.href,location.href);
    if(url.origin===location.origin && url.pathname.includes('/collections/') && !url.searchParams.has('filter.v.availability') && storage.get()!=='all'){
      url.searchParams.set('filter.v.availability','1');link.href=url.href;
    }
  },true);
})();
